import SolicitacaoPagamentoPf from './componentes/SolicitacaoPagamentoPf.vue';
import SolicitacaoPagamentoPfLista from './componentes/SolicitacaoPagamentoPfLista.vue';
import SolicitacaoPagamentoPfForm from './componentes/SolicitacaoPagamentoPfForm.vue';
import SolicitacaoPagamentoRelatorio from './componentes/SolicitacaoPagamentoRelatorio.vue';

export default {
  path: '/solicitacao-pagamento-rateio-pf',
  component: SolicitacaoPagamentoPf,
  meta: { auth: true },
  children: [
    {
      path: '',
      component: SolicitacaoPagamentoPfLista,
      name: 'solicitacao-pagamento-rateio-pf',
    },
    {
      path: 'nova',
      component: SolicitacaoPagamentoPfForm,
      name: 'solicitacao-pagamento-rateio-pf.nova',
    },
    {
      path: ':id/relatorio',
      component: SolicitacaoPagamentoRelatorio,
      name: 'solicitacao-pagamento-rateio-pf.relatorio'
    },
    {
      path: ':idCript',
      component: SolicitacaoPagamentoPfForm,
      name: 'solicitacao-pagamento-rateio-pf.editar'
    }
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento-rateio/fisica/rotas.js